import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';

// Own constants/actions/components
import { getDetailExperienceReviveAction } from 'services/actions/detail-inspire';
import { results, resData } from 'services/selectors/detail-revive';
import LoaderCP from 'components/loader';
import NotFound from 'components/notFound';

const DetailExperienceReviveContainer = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector(results);
  const result = useSelector(resData);

  useEffect(() => {
    dispatch(getDetailExperienceReviveAction(id));
  }, []);

  const renderBody = () => {
    return (
      <div>
        <Container fluid className="bg-white">
          <Container>
            <Row className="py-60">
              <Col lg={9} className="mb-30">
                <Row>
                  <Col lg={12}>
                    <h2>{result.results.title}</h2>
                  </Col>
                  <Col lg={12}>
                    <p className="py-15">
                      {result.results.shortDescription}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <img
                      src={result.results.imageUrl}
                      alt="banner-detail"
                      className="py-15 w-100" />
                  </Col>
                  <Col lg={12}>
                    <p>
                      <ReactMarkdown>{ result.results.longDescription }</ReactMarkdown>
                    </p>
                  </Col>
                  <Col lg={12}>
                    <ul className="custom-list my-15">
                      {
                        result.results.items.map((item) => {
                          return (
                            <li>
                              <i className="fas fa-star icon-green mr-2" />
                              {item}
                            </li>
                          );
                        })
                      }
                    </ul>
                  </Col>
                </Row>
              </Col>
              <Col lg={3} className="mt-lg-60">
                <Row>
                  <Col lg={12} className="mt-lg-10">
                    <div className="bg-color-alabaster p-15 mt-lg-30">
                      <h2>Revive otras Experiencias</h2>
                      {
                        result.results.suggestionList.map((item) => {
                          return (
                            <Link
                              to={`/revive-experiencias/${item.title.split(' ').join('-')}/${item.id}`}
                              className="my-30 d-block not-link"
                              key={item.id}
                              onClick={() => setTimeout(() => window.location.reload(), 500)}>
                              {item.title}
                            </Link>
                          );
                        })
                      }
                    </div>
                  </Col>
                  <Col lg={12}>
                    {
                      result.results.exclusivity !== null && result.results.exclusivity.constant === 'SANTANDER2' ? (
                        <div className="my-15 position-relative">
                          <div className="overlap-image-2 text-center p-30">
                            <h3 className="text-white text-left my-15">Obtén la tarjeta Santander Aeroméxico Infinite</h3>
                            <p className="text-white text-left my-15 ft-50">2 Puntos Aeroméxico Rewards</p>
                            <p className="text-white text-left my-15 mb-30">por cada dolar gastado</p>
                            <a href="/" className="btn btn-primary my-15 btn-absolute-bottom">
                              Clic aquí
                            </a>
                          </div>
                          <img
                            src="https://s3media.aeromexicorewards.com/clubpremierstyleguide/amstyleguide/images/promo-image.jpg"
                            alt="promo"
                            width="100%" />
                        </div>
                      ) : ''
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
    );
  };
  return (
    <div>
      { data.isFetching && <LoaderCP /> }
      { data.error && <NotFound /> }
      { result && result.results && data.isFetching === false && renderBody() }
    </div>
  );
};

export default DetailExperienceReviveContainer;
